/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import classNames from 'classnames';
import { converter } from 'helpers/converter';
import PurchaseButtonTask from 'requests/tasks/card/PurchaseButtonTask';
import RequestManager from 'requests/RequestManager';
import StatusControlPinTask from 'requests/tasks/user/controlPin/statusControlPinTask';
import ClaroUrlBuilder from 'utils/ClaroUrlBuilder';
import { getWorkflowStart } from 'action-creators/payway/workflowStart';
import { setCurrentPBI } from 'action-creators/payway/currentPayment/currentPBI';
import Utils from 'utils/Utils';
import LoadingBlocks from 'components/forms/LoadingBlocks';
import * as actions from 'actions/response';
import * as actionsMetrics from 'action-creators/metrics';
import _ from 'lodash';
import { GetRegion, ANONYMOUS_USER } from 'constants.js';
import * as constants from '../constants';
import { createSearchParams } from 'react-router-dom';
import { getContentListV1 } from 'utils/homologacion/homologacion';

class ModalSuscriptionChannel extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      buttons: null,
      goToPayment: false,
    };
  }

  setMetrics(label, provider) {
    const eventCategory = `suscribete a ${provider}`;

    const eventAction = constants.EVENT_ACTION;
    const eventLabel = label;

    this.props.setMetricsEvent({
      tagManager: {
        event: eventCategory,
        eventCategory,
        eventAction,
        eventLabel,
      },
    });

    this.props.setMetricsEvent({
      type: constants.METRICS_EVENT_TYPE_EXECUTOR,
      success: true,
    });
  }

  closeModal(param) {
    if (param) {
      if (String(param.noTanks) === constants.NOT_THANKS_ACTION) {
        const eventLabel = 'no gracias';
        this.setMetrics(eventLabel, param.provider);
      }
    }

    this.props.closeModal(constants.SUSCRIPTION_CHANEL_MODAL_NAME);
  }

  componentDidMount() {
    const { config, item } = this.props;
    const purchaseButtonTask = new PurchaseButtonTask(config, {
      group_id: item.id || item.group_id,
    });
    RequestManager.addRequest(purchaseButtonTask)
      .then(data => {
        this.setState(prevState => ({
          ...prevState,
          buttons:
            data.listButtons && data.listButtons.button.length
              ? data.listButtons.button
              : [],
          producttype: item.proveedor_code.toLowerCase(),
        }));
      })
      .catch(() => {
        this.setState(prevState => ({ ...prevState, buttons: [] }));
      });
  }

  static getDerivedStateFromProps(nextProps, state) {
    if (window.self !== window.top) {
      if (
        nextProps.payway.workflowStart.data &&
        nextProps.payway.currentPayment.currentPBI
      ) {
        localStorage.setItem(
          'wfsdfp',
          btoa(JSON.stringify(nextProps.payway.workflowStart.data)),
        );
        localStorage.setItem(
          'currentPBI',
          btoa(JSON.stringify(nextProps.payway.currentPayment.currentPBI)),
        );
        window.parent.location = `${
          document.location.origin
        }/${GetRegion()}/payment?fromplayer=1`;
      }
    } else if (state.goToPayment) {
      nextProps.navigate(`/${GetRegion()}/payment`, {
        search: `?${createSearchParams({ fromplayer: 1 })}`,
      });
    }
  }

  convertObjectToQuery(query) {
    return Object.keys(query)
      .map(
        q =>
          (q !== 'linkworkflowstart' && `${q}=${query[q]}`) ||
          `${q}=${encodeURIComponent(query[q])}`,
      )
      .join('&');
  }

  extractLabel(desc) {
    if (desc.indexOf('FOX') !== -1) {
      return constants.SUSCRIPTION_FOX_TEXT;
    }
    return desc;
  }

  getPinStatus = async button => {
    const { config } = this.props;
    let PinStatus = 0;
    try {
      const pinTask = await RequestManager.addRequest(
        new StatusControlPinTask(config),
      );
      PinStatus = Number(pinTask.response.pin_purchase.status);
    } catch (error) {
      console.log(error);
    }
    this.onPurchaseClick(button, PinStatus);
    this.closeModal();
  };

  onPurchaseClick(button, PinStatus) {
    const { item, router, isNewNavigation, navigate } = this.props;
    if (PinStatus === Number(1)) {
      this.renderModalPin(button, item);
    } else {
      const eventLabel = this.extractLabel(button.oneofferdesc);
      const id = item.id || item.group_id;
      const query = this.props.queryParams;
      let urlPlayer = '';
      if (_.has(query, 'guidechannel') || isNewNavigation) {
        urlPlayer = ClaroUrlBuilder.player(id);
      } else {
        urlPlayer = ClaroUrlBuilder.player(id);
      }
      const { oneofferdesc } = button;

      // PATH VARIABLE to get the offer id
      const OFFER_ID = _.get(button, 'offerid');

      let rentParam = '';
      const queryParams = {
        player_url: encodeURIComponent(urlPlayer),
        oneoffertype: button.oneoffertype,
        group_id: id,
        oneofferdesc: button.oneofferdesc,
        title: item.title,
        offer_id: OFFER_ID,
      };

      if (button.linkworkflowstart) {
        queryParams.linkworkflowstart = button.linkworkflowstart;
      }

      if (oneofferdesc.indexOf('24') > -1) {
        rentParam = '24';
      }

      if (oneofferdesc.indexOf('48') > -1) {
        rentParam = '48';
      }

      if (button.oneoffertype === 'download_buy') {
        rentParam = 'compra';
      }

      if (button.oneoffertype && button.oneoffertype.indexOf('event') !== -1) {
        rentParam = 'event_live';
      }

      if (getContentListV1?.IsLive(item)) {
        queryParams.live = '1';
      }

      if (button.oneoffertype !== 'subscrition') {
        queryParams.isrent = rentParam;
        queryParams.offertype = button.oneoffertype;
      }

      // Gtres FLOW
      if (button.price) {
        queryParams.price = button.price;
      }

      if (item.title_uri) {
        queryParams.titleUri = item.title_uri;
      }

      if (this.props.user.userType === ANONYMOUS_USER) {
        this.setMetrics(eventLabel, item.proveedor_code);
        if (window.self !== window.top) {
          window.parent.location = `${
            document.location.origin
          }/${GetRegion()}/register?${this.convertObjectToQuery(queryParams)}`;
        } else {
          this.props.navigate(
            `/${GetRegion()}/register?${createSearchParams(queryParams)}`,
            {},
          );
        }
        this.closeModal();
        return;
      }
      if (window.self !== window.top) {
        this.props.getWorkflowStart(queryParams.linkworkflowstart);
      } else {
        this.setMetrics(eventLabel, item.proveedor_code);
        this.props.getWorkflowStart(queryParams.linkworkflowstart);
      }
      this.props.invokeSetCurrentPBI(button);
      this.setState(prevState => ({ ...prevState, goToPayment: true }));
    }
  }

  renderModalPin(button, item) {
    const modalType = 'Pin';
    const modal = this.getModal('', modalType, button, item, () => {
      this.props.removeModal(modalType);
      this.props.onCancel(modalType);
    });
    this.props.showModal(modal);
  }

  getModal = (message, modalType, button, item, onAccept) => ({
    modalType,
    props: {
      message,
      button,
      onAccept,
      item,
      hrefMyAccount: ClaroUrlBuilder.myAccount(this.props.user.region),
    },
  });

  renderListButtons() {
    const { buttons } = this.state;
    const { translations, item } = this.props;

    const offerId = _.get(this.state, 'buttons[0].offerid');

    const fallbackCancel = converter.convertApaUnicode(
      translations,
      `${item.proveedor_code}_cancel_button`,
      constants.PROVIDER_SUSC_CANCEL_BUTTON,
    );

    const cancelBtnText = converter.convertApaUnicode(
      translations,
      `${offerId}_cancel_button`,
      fallbackCancel,
    );

    const cancelButton = (
      <button
        type="button"
        key="cancel_button"
        className={constants.classButtonInactive}
        onClick={this.closeModal.bind(this, {
          noTanks: constants.NOT_THANKS_ACTION,
          provider: item.proveedor_code,
        })}
      >
        {cancelBtnText}
      </button>
    );
    const arrayButtons = [cancelButton];

    if (!buttons) {
      return <></>;
    }
    if (buttons.length === 0) {
      return cancelButton;
    }
    const offerButtons = buttons.map(button => {
      const fallbackText = converter.convertApaUnicode(
        translations,
        `${button.offerid}_forced_label`,
        button.oneofferdesc,
      );

      const textButton = converter.convertApaUnicode(
        translations,
        `${button.offerid}_susc_suscription_button`,
        fallbackText,
      );

      return (
        <button
          key={button.offerid}
          type="button"
          className={constants.classButtonActive}
          onClick={this.getPinStatus.bind(this, button)}
        >
          <span className="pull-left antes_renta">{`${textButton} `}</span>
        </button>
      );
    });
    return [...arrayButtons, ...offerButtons];
  }

  renderIcon(classes) {
    const assetKey = `${this.props.item.proveedor_code}_susc_icon`;
    const srcAsset = this.props.apaAssets[assetKey];
    if (srcAsset) {
      return <img src={srcAsset} alt="icon" />;
    }
    return <i className={classes} />;
  }

  render() {
    const { iconClass, translations } = this.props;
    const { buttons } = this.state;
    const customIconClass = iconClass || false;
    const classes = {
      fa: true,
      'text-center': true,
      'fa-3x': true,
      'fa-check': !customIconClass,
    };
    if (customIconClass) classes[customIconClass] = customIconClass;
    const classesForBody = classNames(classes);
    const offerId = _.get(this.state, 'buttons[0].offerid');

    const fallBackTitle =
      (this.state.producttype &&
        converter.convertApaUnicode(
          translations,
          `${this.state.producttype}_susc_title`,
          constants.FOX_PLUS_PREMIUM_SUC_TITLE,
        )) ||
      constants.FOX_PLUS_PREMIUM_SUC_TITLE;

    const suscTitle = converter.convertApaUnicode(
      translations,
      `${offerId}_susc_title`,
      fallBackTitle,
    );

    const fallBackDesc =
      (this.state.producttype &&
        converter.convertApaUnicode(
          translations,
          `${this.state.producttype}_susc_description`,
          constants.FOX_PLUS_SUSC_DESCRIPTION,
        )) ||
      constants.FOX_PLUS_SUSC_DESCRIPTION;

    const suscDesc =
      this.state.producttype &&
      converter.convertApaUnicode(
        translations,
        `${offerId}_susc_description`,
        fallBackDesc,
      );

    return (
      <Modal show>
        <Modal.Header>
          <Button className="close close-modal" onClick={this.closeModal}>
            x
          </Button>
        </Modal.Header>
        <Modal.Body className="modal-body text-center success">
          {this.renderIcon(classesForBody)}
          {!buttons && <LoadingBlocks />}
          {buttons && (
            <>
              <h4
                className="text-center"
                dangerouslySetInnerHTML={{
                  __html: suscTitle,
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: suscDesc,
                }}
              />
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div>{this.renderListButtons()}</div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalSuscriptionChannel.propTypes = {
  translations: PropTypes.shape({}),
  iconClass: PropTypes.string,
  item: PropTypes.shape({
    proveedor_code: PropTypes.string,
  }),
  apaAssets: PropTypes.shape({}),
  user: PropTypes.shape({
    region: PropTypes.string,
    userType: PropTypes.string,
  }),
  removeModal: PropTypes.func,
  showModal: PropTypes.func,
  onCancel: PropTypes.func,
  router: PropTypes.func,
  config: PropTypes.shape({}),
  setMetricsEvent: PropTypes.func,
  closeModal: PropTypes.func,
  isNewNavigation: PropTypes.bool,
};

const mapStateToProps = state => ({
  translations: state.translations,
  apaAssets: state.asset,
  config: state.config,
  user: state.user,
  router: state.routing,
  payload: state.metrics.payload,
  payway: state.payway,
  state,
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  setMetricsEvent(options) {
    dispatch(actionsMetrics.setMetricsEvent(options));
  },
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
  getWorkflowStart(linkworkflowstart) {
    dispatch(getWorkflowStart(linkworkflowstart));
  },
  invokeSetCurrentPBI: pbi => dispatch(setCurrentPBI(pbi)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalSuscriptionChannel);
